import { render, staticRenderFns } from "./satisfaction.vue?vue&type=template&id=471a0c2c"
import script from "./satisfaction.vue?vue&type=script&lang=js"
export * from "./satisfaction.vue?vue&type=script&lang=js"
import style0 from "./satisfaction.vue?vue&type=style&index=0&id=471a0c2c&prod&lang=scss&sc=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports